"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var clsx_1 = __importDefault(require("clsx"));
var PREFIX = 'CheckboxGroup';
var classes = {
    radioLabel: "".concat(PREFIX, "-radioLabel"),
    selected: "".concat(PREFIX, "-selected"),
    root: "".concat(PREFIX, "-root"),
};
var StyledFormLabel = (0, styles_1.styled)(material_1.FormControlLabel)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.radioLabel)] = {
            padding: theme.spacing(0.5, 0),
            border: "1px solid ".concat(theme.palette.grey[400]),
            borderRadius: 8,
            margin: theme.spacing(2, 0),
            '&:hover': {
                backgroundColor: theme.palette.secondary.light,
            },
        },
        _b[".".concat(classes.selected)] = {
            borderColor: theme.palette.secondary.main,
        },
        _b[".".concat(classes.root)] = {
            color: theme.palette.grey[400],
        },
        _b);
});
var CheckboxGroup = function (_a) {
    var _b = _a.input, onChange = _b.onChange, value = _b.value, options = _a.options;
    var selectedOptions = (value || []);
    var selectOption = function (option) { return onChange(__spreadArray([], __read(selectedOptions.concat(option)), false)); };
    var deselectOption = function (option) { return onChange(selectedOptions.filter(function (sV) { return sV !== option; })); };
    return options.map(function (option) { return ((0, jsx_runtime_1.jsx)(StyledFormLabel, { className: (0, clsx_1.default)(classes.radioLabel, (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.includes(option.value)) ? classes.selected : ''), value: option.value, checked: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.includes(option.value), control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { classes: { root: classes.root } }), label: option.label, onChange: function (e) { return e.currentTarget.checked
            ? selectOption(e.currentTarget.value)
            : deselectOption(e.currentTarget.value); } }, option.value)); });
};
exports.default = CheckboxGroup;
